import { Pipe, PipeTransform } from '@angular/core';
import { DateFnsTimeFormat, TIME_PREF_12H } from 'src/app/enums/timePreference.enum';
import { DateFormatService } from 'src/app/services/dateFormat.service';

@Pipe({
  standalone: false,
  name: 'hour12Flag',
})

export class hour12FlagPipe implements PipeTransform {
  constructor(private dateFormatService: DateFormatService) { }
  transform(_value?: unknown): 12 | 24 {
    return DateFnsTimeFormat[this.dateFormatService.userTimeFormat] == TIME_PREF_12H ? 12 : 24;
  }
}
